module.exports = __webpack_public_path__ + "img/KG.f9e104bf.png";